/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import * as types from './mutation-types'

export default {
  [types.LOADING_ENGINE](state, payload) {
    state.loading = payload;
  },
  [types.LOADING_INFO](state, payload) {
    state.info.loading = payload;
  },
  [types.SET_ENGINE_STATUS](state, payload) {
    state.on = payload
  },
  [types.UPDATE_ENGINE_INFO](state, payload) {
    state.info = {
      ...state.info,
      ...payload,
    }
  },
}
